(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-light-bulb-effect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Single-init guard: Shopify re-executes section JS on every
    // shopify:section:load (theme-editor re-render), which would otherwise
    // stack another window 'mousemove' listener each time. Register at most once.
    if (window.__egLightBulbInit) return;
    window.__egLightBulbInit = true;

    var el = document.querySelector('.eg-light-bulb');
    if (!el) return;
    // Capture the owning section's id BEFORE relocating to <body>, so the unload
    // handler can tell our own removal apart from any other section unloading.
    var ownerSection = el.closest('.shopify-section');
    var ownerId = ownerSection ? ownerSection.id : null;
    if (el.parentNode !== document.body) document.body.appendChild(el);

    var x = 0;
    var y = 0;
    var ticking = false;
    var active = false;

    function render() {
      ticking = false;
      el.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) translate(-50%, -50%)';
      if (!active) {
        active = true;
        el.classList.add('is-active');
      }
    }

    function onMove(e) {
      x = e.clientX;
      y = e.clientY;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(render);
      }
    }

    window.addEventListener('mousemove', onMove, { passive: true });

    // Theme editor: when THIS section is removed, drop the listener, clear the
    // relocated node and reset the flag so a later re-add can cleanly re-init.
    // The unload handler removes itself too, so it can't accumulate across
    // repeated add/remove cycles.
    function onUnload(e) {
      if (ownerId && e.target && e.target.id !== ownerId) return;
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('shopify:section:unload', onUnload);
      if (el && el.parentNode) el.parentNode.removeChild(el);
      window.__egLightBulbInit = false;
    }
    document.addEventListener('shopify:section:unload', onUnload);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-livestream"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (window.customElements && customElements.get('eg-livestream')) return;

    /* Extract a YouTube video id from a full URL or a bare id. */
    function parseYouTubeId(raw) {
      if (!raw) return '';
      raw = String(raw).trim();
      if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw;
      var patterns = [
        /[?&]v=([a-zA-Z0-9_-]{11})/,
        /youtu\.be\/([a-zA-Z0-9_-]{11})/,
        /\/live\/([a-zA-Z0-9_-]{11})/,
        /\/embed\/([a-zA-Z0-9_-]{11})/,
        /\/shorts\/([a-zA-Z0-9_-]{11})/
      ];
      for (var i = 0; i < patterns.length; i++) {
        var m = raw.match(patterns[i]);
        if (m) return m[1];
      }
      return '';
    }

    function embedSrc(id, autoplay, muted) {
      var p = [
        'playsinline=1',
        'rel=0',
        'modestbranding=1',
        'autoplay=' + (autoplay ? '1' : '0'),
        'mute=' + (muted ? '1' : '0')
      ];
      return 'https://www.youtube-nocookie.com/embed/' + id + '?' + p.join('&');
    }

    function preconnect() {
      ['https://www.youtube-nocookie.com', 'https://www.youtube.com', 'https://i.ytimg.com'].forEach(function (href) {
        if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
        var l = document.createElement('link');
        l.rel = 'preconnect';
        l.href = href;
        l.crossOrigin = '';
        document.head.appendChild(l);
      });
    }

    class EGLivestream extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.floatingOnly = this.dataset.floatingOnly === 'true';
        this.floatEl = this.querySelector('[data-float]');
        this.panel = this.querySelector('[data-panel]');
        this.titleEl = this.querySelector('[data-title]');

        // Relocate the floating control to <body> so position:fixed cannot be
        // trapped by a transformed ancestor section.
        if (this.floatEl && this.floatEl.parentNode !== document.body) {
          document.body.appendChild(this.floatEl);
        }

        if (this.floatEl) {
          if (this.floatingOnly) {
            // Real link; ensure it is shown (it already ships with is-visible).
            this.showFloat();
          } else {
            this._onFloatClick = this.scrollToPlayer.bind(this);
            this.floatEl.addEventListener('click', this._onFloatClick);
          }
        }

        if (this.floatingOnly) return;

        this.setupLazyLoad();
        this.setupVisibilityObserver();
      }

      disconnectedCallback() {
        if (this.loadObserver) {
          this.loadObserver.disconnect();
          this.loadObserver = null;
        }
        if (this.visObserver) {
          this.visObserver.disconnect();
          this.visObserver = null;
        }
        if (this.floatEl) {
          if (this._onFloatClick) this.floatEl.removeEventListener('click', this._onFloatClick);
          if (this.floatEl.parentNode) this.floatEl.parentNode.removeChild(this.floatEl);
          this.floatEl = null;
        }
        this._init = false;
      }

      setupLazyLoad() {
        const self = this;
        const iframe = this.querySelector('[data-iframe]');
        const id = parseYouTubeId(this.dataset.youtube);

        if (!iframe || !id) {
          // No stream linked yet — drop the spinner, keep the ambient placeholder.
          const spinner = this.querySelector('[data-placeholder] .eg-livestream__spinner');
          if (spinner) spinner.style.display = 'none';
          return;
        }

        let loaded = false;
        function load() {
          if (loaded) return;
          loaded = true;
          preconnect();
          const placeholder = self.querySelector('[data-placeholder]');
          const badge = self.querySelector('[data-live-badge]');
          const unmute = self.querySelector('[data-unmute]');
          const autoplay = self.dataset.autoplay === 'true';
          const muted = self.dataset.muted === 'true';

          iframe.addEventListener('load', function () {
            if (placeholder) placeholder.hidden = true;
            if (badge) badge.hidden = false;
            if (unmute && muted) unmute.hidden = false;
          });
          iframe.src = embedSrc(id, autoplay, muted);
          iframe.hidden = false;

          if (unmute) {
            unmute.addEventListener('click', function () {
              // A user gesture lets us reload with sound.
              iframe.src = embedSrc(id, true, false);
              unmute.hidden = true;
            });
          }
        }

        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(function (entries) {
            for (let i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                load();
                if (self.loadObserver) self.loadObserver.disconnect();
                break;
              }
            }
          }, { rootMargin: '400px 0px' });
          this.loadObserver.observe(this.panel || this);
        } else {
          load();
        }
      }

      setupVisibilityObserver() {
        const self = this;
        if (!this.floatEl) return;
        if (this.dataset.showFloat !== 'true') return;
        if (!('IntersectionObserver' in window)) return;

        this.visObserver = new IntersectionObserver(function (entries) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) self.hideFloat();
            else self.showFloat();
          }
        }, { threshold: 0 });
        this.visObserver.observe(this.panel || this);
      }

      showFloat() {
        if (!this.floatEl) return;
        this.floatEl.hidden = false;
        const el = this.floatEl;
        requestAnimationFrame(function () {
          el.classList.add('is-visible');
        });
      }

      hideFloat() {
        if (this.floatEl) this.floatEl.classList.remove('is-visible');
      }

      scrollToPlayer(e) {
        if (e) e.preventDefault();
        const target = this.panel || this;
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        } catch (_e) {
          target.scrollIntoView();
        }
        if (this.titleEl) {
          const t = this.titleEl;
          t.setAttribute('tabindex', '-1');
          window.setTimeout(function () {
            try { t.focus({ preventScroll: true }); } catch (_e2) { t.focus(); }
          }, 500);
        }
      }
    }

    customElements.define('eg-livestream', EGLivestream);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-password-cinema"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MOUNTED = 'eg-cinema--mounted';
    var SECTION_SELECTOR = '.eg-cinema';
    var inertedSiblings = [];

    /* Extract a YouTube video id from a full URL or a bare id. */
    function parseYouTubeId(raw) {
      if (!raw) return '';
      raw = raw.trim();
      if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw;
      var patterns = [
        /[?&]v=([a-zA-Z0-9_-]{11})/,
        /youtu\.be\/([a-zA-Z0-9_-]{11})/,
        /\/live\/([a-zA-Z0-9_-]{11})/,
        /\/embed\/([a-zA-Z0-9_-]{11})/,
        /\/shorts\/([a-zA-Z0-9_-]{11})/
      ];
      for (var i = 0; i < patterns.length; i++) {
        var m = raw.match(patterns[i]);
        if (m) return m[1];
      }
      return '';
    }

    function embedSrc(id, autoplay, muted) {
      var p = [
        'playsinline=1',
        'rel=0',
        'modestbranding=1',
        'autoplay=' + (autoplay ? '1' : '0'),
        'mute=' + (muted ? '1' : '0')
      ];
      return 'https://www.youtube-nocookie.com/embed/' + id + '?' + p.join('&');
    }

    function preconnect() {
      ['https://www.youtube-nocookie.com', 'https://www.youtube.com', 'https://i.ytimg.com'].forEach(function (href) {
        if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
        var l = document.createElement('link');
        l.rel = 'preconnect';
        l.href = href;
        l.crossOrigin = '';
        document.head.appendChild(l);
      });
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    /* Make every <body> child except the overlay inert + hidden from AT, so the
       password form, footer and main content can't be tabbed/announced behind
       the take-over. Skipped in the theme editor (overlay isn't relocated). */
    function inertBackground(root) {
      if (root.dataset.design === 'true') return;
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k === root) continue;
        if (k.tagName === 'SCRIPT' || k.tagName === 'LINK' || k.tagName === 'STYLE') continue;
        var addInert = !k.hasAttribute('inert');
        var addAria = !k.hasAttribute('aria-hidden');
        if (!addInert && !addAria) continue; // already hidden by the author — leave as-is
        if (addInert) k.setAttribute('inert', '');
        if (addAria) k.setAttribute('aria-hidden', 'true');
        // Track only what we added so restore never clobbers author-set state.
        inertedSiblings.push({ el: k, inert: addInert, aria: addAria });
      }
    }

    function restoreBackground() {
      for (var i = 0; i < inertedSiblings.length; i++) {
        var rec = inertedSiblings[i];
        if (rec.inert) rec.el.removeAttribute('inert');
        if (rec.aria) rec.el.removeAttribute('aria-hidden');
      }
      inertedSiblings = [];
    }

    function activate(root) {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      document.body.classList.add('eg-cinema-active');
      root.hidden = false;
      inertBackground(root);

      /* --- Curtain reveal --- */
      var wantsCurtain = root.dataset.curtain === 'true' && !prefersReduced;
      if (wantsCurtain) {
        // Force a frame so the transition runs from the closed state.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.classList.add('is-open'); });
        });
        // Fallback: if rAF is throttled (e.g. the tab painted late), still open.
        window.setTimeout(function () { root.classList.add('is-open'); }, 250);
      } else {
        root.classList.add('is-open');
      }

      /* --- Move focus into the overlay (not in the theme editor) --- */
      if (root.dataset.design !== 'true') {
        var titleEl = root.querySelector('.eg-cinema__title');
        if (titleEl) {
          try { titleEl.focus({ preventScroll: true }); } catch (e) { titleEl.focus(); }
        }
      }

      /* --- Livestream --- */
      var iframe = root.querySelector('[data-iframe]');
      var placeholder = root.querySelector('[data-placeholder]');
      var badge = root.querySelector('[data-live-badge]');
      var unmuteBtn = root.querySelector('[data-unmute]');
      var ytLink = root.querySelector('[data-yt-link]');
      var id = parseYouTubeId(root.dataset.youtube);
      var autoplay = root.dataset.autoplay === 'true';
      var startMuted = root.dataset.muted === 'true';

      if (id) {
        preconnect();
        if (ytLink) {
          ytLink.href = 'https://www.youtube.com/watch?v=' + id;
          ytLink.hidden = false;
        }
        if (iframe) {
          iframe.addEventListener('load', function () {
            if (placeholder) placeholder.hidden = true;
            if (badge) badge.hidden = false;
            if (unmuteBtn && startMuted) unmuteBtn.hidden = false;
          });
          iframe.src = embedSrc(id, autoplay, startMuted);
          iframe.hidden = false;
        }
        if (unmuteBtn) {
          unmuteBtn.addEventListener('click', function () {
            // A user gesture lets us reload with sound (autoplay-with-audio is then allowed).
            iframe.src = embedSrc(id, true, false);
            unmuteBtn.hidden = true;
          });
        }
      } else if (placeholder) {
        // No stream linked yet — keep the ambient placeholder, drop the spinner.
        var spinner = placeholder.querySelector('.eg-cinema__spinner');
        if (spinner) spinner.style.display = 'none';
      }

      /* --- Countdown --- */
      startCountdown(root);
    }

    function startCountdown(root) {
      var iso = root.dataset.target;
      var unit = root.dataset.unit || '';
      var counts = root.querySelectorAll('[data-count]');
      var fill = root.querySelector('[data-progress-fill]');
      var srEl = root.querySelector('[data-sr]');
      var enterBtn = root.querySelector('[data-enter]');
      var autoReload = root.dataset.autoReload === 'true';

      if (enterBtn) {
        enterBtn.addEventListener('click', function () { window.location.reload(); });
      }

      var target = iso ? new Date(iso) : null;
      if (!target || isNaN(target.getTime())) {
        for (var i = 0; i < counts.length; i++) counts[i].textContent = '--:--';
        return;
      }

      var startMs = Date.now();
      var startRemaining = target.getTime() - startMs;
      var lastMinute = -1;
      var expired = false;
      // Clear any interval left over from a previous activation of this same node
      // (theme-editor re-render can re-activate without a fresh mount).
      if (root.__egCineTimer) window.clearInterval(root.__egCineTimer);

      function setText(value) {
        for (var i = 0; i < counts.length; i++) counts[i].textContent = value;
      }

      function setExpired() {
        if (expired) return;
        expired = true;
        root.classList.add('is-expired');
        var expiredTitle = root.dataset.expiredTitle;
        if (expiredTitle) {
          var titleEl = root.querySelector('.eg-cinema__title');
          if (titleEl) titleEl.textContent = expiredTitle;
          if (srEl) srEl.textContent = expiredTitle;
        }
        if (enterBtn) {
          enterBtn.hidden = false;
          try { enterBtn.focus({ preventScroll: true }); } catch (e) { enterBtn.focus(); }
        }
        if (autoReload) {
          window.setTimeout(function () { window.location.reload(); }, 4000);
        }
      }

      function tick() {
        var distance = target.getTime() - Date.now();
        if (distance <= 0) {
          setText('00:00');
          setExpired();
          window.clearInterval(root.__egCineTimer);
          root.__egCineTimer = null;
          return;
        }

        // MM:SS where minutes may exceed 59, so the "Minuten" unit always fits.
        var totalSeconds = Math.floor(distance / 1000);
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        var label = pad(minutes) + ':' + pad(seconds);
        setText(label);

        if (fill && startRemaining > 0) {
          var elapsed = startRemaining - distance;
          var pct = Math.max(0, Math.min(100, (elapsed / startRemaining) * 100));
          fill.style.width = pct.toFixed(2) + '%';
        }

        if (srEl && minutes !== lastMinute) {
          lastMinute = minutes;
          srEl.textContent = label + ' ' + unit;
        }
      }

      tick();
      // Store on the element so teardown paths (boot supersede / section unload)
      // can clear it before removing the node — otherwise detached nodes keep ticking.
      root.__egCineTimer = window.setInterval(tick, 1000);
    }

    /* Clear a node's countdown interval, then remove it from the DOM. */
    function removeOverlay(node) {
      if (node.__egCineTimer) {
        window.clearInterval(node.__egCineTimer);
        node.__egCineTimer = null;
      }
      node.remove();
    }

    function shouldActivate(root) {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
      var mode = params ? params.get('mode') : null;
      if (mode === 'normal') return false;          // explicit opt-out for quick checks
      if (mode === 'cinema') return true;            // live preview
      return root.dataset.enabled === 'true';        // merchant toggle (incl. theme editor)
      // NB: in the theme editor an inactive section is kept in the DOM (see boot)
      // so it stays selectable, but it does NOT take over unless actually enabled.
    }

    function boot(scope) {
      var root = scope && scope.matches && scope.matches(SECTION_SELECTOR)
        ? scope
        : (scope && scope.querySelector ? scope.querySelector(SECTION_SELECTOR) : null);
      if (!root) return;

      // Remove any previously mounted overlay (theme-editor re-render safety).
      var mounted = document.querySelectorAll('body > ' + SECTION_SELECTOR + '.' + MOUNTED);
      for (var i = 0; i < mounted.length; i++) {
        if (mounted[i] !== root) removeOverlay(mounted[i]);
      }
      if (root.classList.contains(MOUNTED)) return;

      if (!shouldActivate(root)) {
        // In the theme editor keep the node so the merchant can still select it.
        if (root.dataset.design !== 'true') removeOverlay(root);
        if (!document.querySelector(SECTION_SELECTOR + '.' + MOUNTED)) {
          document.body.classList.remove('eg-cinema-active');
          restoreBackground();
        }
        return;
      }

      root.classList.add(MOUNTED);
      // Relocate to <body> so position:fixed escapes any transformed ancestor.
      // Skipped in the editor so section selection/targeting keeps working.
      if (root.dataset.design !== 'true' && root.parentNode !== document.body) {
        document.body.appendChild(root);
      }
      activate(root);
    }

    function initAll() {
      var nodes = document.querySelectorAll(SECTION_SELECTOR);
      for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-init when the section is re-rendered.
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function () {
      var mounted = document.querySelectorAll('body > ' + SECTION_SELECTOR + '.' + MOUNTED);
      for (var i = 0; i < mounted.length; i++) removeOverlay(mounted[i]);
      document.body.classList.remove('eg-cinema-active');
      restoreBackground();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
